'use strict';/*jslint ts:true, react:true*/
import React, {useContext} from 'react';
import {Editor} from '../../../shared/editor/editor';
import {Settings_context} from '../settings_ctx';
import styles from './game_boost_why_free_banner.module.less';
import cn from 'classnames';

interface i_game_boost_why_free_banner_props {
    label: string;
    text: string;
    highlight_blue: string;
    highlight_pink: string;
    highlight_green: string;
}

export const Game_boost_why_free_banner = (
props: i_game_boost_why_free_banner_props)=>{
    const {label, text, highlight_blue, highlight_pink,
        highlight_green} = props;
    const {theme} = useContext(Settings_context);
    return <div className={styles.wrapper}>
      <p className={cn([theme.u2, styles.label])}>{label}</p>
      <div className={styles.text}>
        <p>{text}</p>
        <p>
          <span className={styles.blue}>{highlight_blue}</span>{' '}
          <span className={styles.pink}>{highlight_pink}</span>{' '}
          <span className={styles.green}>{highlight_green}</span>
        </p>
      </div>
    </div>;
};

interface i_game_boost_why_free_banner_editor_props {
    value: i_game_boost_why_free_banner_props;
    on_change: (new_val: i_game_boost_why_free_banner_props)=>void;
}

export const Game_boost_why_free_banner_editor = (
{value, on_change}: i_game_boost_why_free_banner_editor_props)=>{
    return <Editor value={value} on_change={on_change}
      editors={[
        {key: 'label', label: 'Label', type: 'text'},
        {key: 'text', label: 'Text', type: 'textarea'},
        {key: 'highlight_blue', label: 'Blue highlight', type: 'text'},
        {key: 'highlight_pink', label: 'Pink highlight', type: 'text'},
        {key: 'highlight_green', label: 'Green highlight', type: 'text'},
      ]}/>;
};
